import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export default {
    /**
     * Swiper component with events
     */
    EventsSwiper() {
        /**
         * Find the elements for the component
         */
        document.querySelectorAll('[data-component="events-swiper"]').forEach((component) => {
            if (!component.hasAttribute('data-source') || component.getAttribute('data-source') == '') {
                return false;
            }

            /**
             * Fetch the content for the section
             */
            fetch(component.getAttribute('data-source'), {
                'method': 'GET',
            })
            .then(response => response.text())
            .then(result => {
                /**
                 * Verify that we have content for the component
                 */
                if (!result || result.trim() == '') {
                    return false;
                }

                /**
                 * Set the content of the response
                 */
                component.innerHTML = result;

                /**
                 * Verify that now in the component we have the slider
                 */
                if (component.querySelector('[data-element="swiper"]')) {
                    /**
                     * Setup the component
                     */
                    const slider = new Swiper(component.querySelector('[data-element="swiper"]'), {
                        modules: [Navigation, Pagination, Autoplay],
                        speed: 400,
                        autoplay: {
                            delay: 3000,
                        },
                        // enabled: true,
                        // noSwiping: true,
                        slidesPerView: 1,
                        spaceBetween: 10,
                        // loop: true,
                        // Navigation arrows
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                    });

                    /**
                     * Initialzie the component
                     */
                    slider.loopDestroy();
                }
            });
        });
    },
    /**
     * Swiper component with general sliders
     */
    GeneralSwiper() {
        /**
         * Find the elements for the component
         */
        document.querySelectorAll('[data-component="swiper"]').forEach((component) => {
            /**
             * Setup the component
             */
            const slider = new Swiper(component, {
                modules: [Navigation, Pagination, Autoplay],
                speed: 400,
                autoplay: {
                    delay: 3000,
                },
                // enabled: true,
                // noSwiping: true,
                slidesPerView: 1,
                spaceBetween: 10,
                // loop: true,
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });

            /**
             * Initialzie the component
             */
            slider.loopDestroy();
        });
    },
};
